import { Segment } from '../model/segment';
import { BotElement } from '../types/model-types';

class BotState {
  segment: Segment;
  activeIndex: number = 0;
  context: object = {};
  forLoopState: ForLoopState | null = null;

  constructor(segment: Segment) {
    this.segment = segment;
  }

  newStateWithContext(context: object): BotState {
    let newState = new BotState(this.segment);
    newState.activeIndex = this.activeIndex;
    newState.forLoopState = this.forLoopState;
    newState.context = context;

    return newState;
  }
}


class ForLoopState {
  parent: ForLoopState | null = null;
  index: number = 0;
  varName: string;

  constructor(varName: string) {
    this.varName = varName;
  }

  get loopContextVar(): string {
    return `${this.varName}__info`;
  }

  newContextWithForloop(context: object): object {
    let forloopContext = new ForLoopContext(this, context);
    return {...context, forloop: forloopContext};
  }
}


class ForLoopContext {
  private state: ForLoopState;
  private activeContext: object;

  constructor(state: ForLoopState, context: object) {
    this.state = state;
    this.activeContext = context;
  }

  get parentloop(): ForLoopContext | null {
    if (this.state.parent !== null) {
      return new ForLoopContext(this.state.parent, this.activeContext)
    } else {
      return null;
    }
  }

  get counter0(): number {
    return this.state.index;
  }

  get counter(): number {
    return this.counter0 + 1;
  }

  get first(): boolean {
    return this.state.index === 0;
  }

  get last(): boolean {
    let context: any = this.activeContext
    return this.counter === context[this.state.varName].length;
  }

  get currentValue(): any {
    let context: any = this.activeContext;
    let state = this.state;
    return context[this.state.varName][this.state.index];
  }

  value(varName: string): any {
    let context: any = this.activeContext;
    return context[this.state.loopContextVar][this.state.index][varName];
  }
}

class BotRequest {
    state: BotState;
    input: object;

    constructor(state: BotState, input?: object | string, presentation?: string) {
        this.state = state;
        let inputObject: any = {}
        if (input instanceof Object) {
            inputObject = input;
        } else {
            if (input !== undefined) {
                inputObject['id'] = input;
            }
            if (presentation !== undefined) {
                inputObject['presentation'] = presentation;
            }
        }
        this.input = inputObject;
    }
}

class ResponseElement {
  segment: Segment;
  index: number;
  element: BotElement;
  renderContext: Object;

  constructor(segment: Segment, index: number, element: BotElement, renderContext: Object) {
      this.segment = segment;
      this.index = index;
      this.element = element;
      this.renderContext = renderContext;
  }
}

class BotResponse {
  state: BotState;
  elements: ResponseElement[] = [];
  request?: BotRequest;

  constructor(state: BotState, elements?: ResponseElement[]) {
    this.state = state;
    if (elements !== undefined) {
      this.elements = elements;
    }
  }
}

class BotErrorResponse extends BotResponse {
  request: BotRequest;
  message: string;

  constructor(request: BotRequest, message: string) {
      super(request.state);
      this.request = request;
      this.message = message;
  }
}


export {
  BotState,
  BotRequest,
  BotResponse,
  BotErrorResponse,
  ResponseElement,
  ForLoopState,
}
